import Link from 'next/link'
import DiscordIcon from '../icons/DiscordIcon'
import { XIcon } from '../icons/XIcon'
import { LogoFull } from '../Logo'
import useThemeWrapper from 'hooks/useThemeWrapper'
import { DISCORD_LINK, TELEGRAM_LINK, TWITTER_LINK } from 'utils/constants'
import { useTranslation } from 'next-i18next'
import { ExternalLink } from '@components/shared/ExternalLink'
import SeasonEndedBadge from '@components/shared/SeasonEndedBadge'
import TelegramIcon from '@components/icons/TelegramIcon'

const Footer = () => {
  const { theme } = useThemeWrapper()
  const { t } = useTranslation('footer')
  return (
    <div className={`bg-th-bkg-1`}>
      <div
        className={`h-3 w-full bg-[url('/images/wavey-line.svg')] bg-repeat-x ${
          theme === 'Light' ? 'opacity-10' : ''
        }`}
      />
      <div className="mx-auto max-w-[1680px]">
        <div className="grid grid-cols-4 gap-8 px-4 py-6 md:gap-4 md:px-6 md:py-8">
          <div className="order-3 col-span-4 md:order-1 md:col-span-2 lg:col-span-1">
            <div className="flex h-full flex-col justify-between">
              <div>
                <div className="mb-6">
                  <LogoFull className="h-7 w-auto text-th-fgd-1" />
                </div>
                <div className="mb-3 flex items-center space-x-4">
                  <ExternalLink
                    className="text-th-fgd-2 md:hover:text-th-fgd-3"
                    href={DISCORD_LINK}
                  >
                    <DiscordIcon className="size-4" />
                  </ExternalLink>
                  <ExternalLink
                    className="text-th-fgd-2 md:hover:text-th-fgd-3"
                    href={TWITTER_LINK}
                  >
                    <XIcon className="size-4" />
                  </ExternalLink>
                  <ExternalLink
                    className="text-th-fgd-2 md:hover:text-th-fgd-3"
                    href={TELEGRAM_LINK}
                  >
                    <TelegramIcon className="size-4" />
                  </ExternalLink>
                </div>
              </div>
              <p className="text-xs text-th-fgd-3">
                {t('copyright', { year: new Date().getFullYear() })}
              </p>
            </div>
          </div>
          <div className="order-1 col-span-4 space-y-2 md:order-2 md:col-span-1">
            <h4 className="font-semibold text-th-fgd-4">
              {t('sections.get-filled')}
            </h4>
            <Link
              className="block text-th-fgd-2 md:hover:text-th-fgd-3"
              href="/"
            >
              {t('links.trade-sol')}
            </Link>
            <Link
              className="block text-th-fgd-2 md:hover:text-th-fgd-3"
              href="/trending"
            >
              {t('links.trending')}
            </Link>
            <Link
              className="block text-th-fgd-2 md:hover:text-th-fgd-3"
              href="/swap"
            >
              {t('links.swap')}
            </Link>
            <Link
              className="relative inline-block text-th-fgd-2 md:hover:text-th-fgd-3"
              href="/leaderboard"
            >
              {t('links.leaderboard')}
              <SeasonEndedBadge
                text={t('links.season-1-ended')}
                className="pointer-events-none absolute -right-8 -top-2 rotate-6 shadow-sm"
              />
            </Link>
            {/* HIDDEN_PROFILES_REFERRALS: revert via PROFILES_AND_REFERRALS_HIDDEN.md
            <Link
              className="block text-th-fgd-2 md:hover:text-th-fgd-3"
              href="/referrals"
            >
              Referrals
            </Link>
            */}
          </div>
          <div className="order-2 col-span-4 space-y-2 md:order-3 md:col-span-1">
            <h4 className="font-semibold text-th-fgd-4">
              {t('sections.resources')}
            </h4>
            <Link
              className="block text-th-fgd-2 md:hover:text-th-fgd-3"
              href="/terms-of-use"
            >
              {t('links.terms')}
            </Link>
            <Link
              className="block text-th-fgd-2 md:hover:text-th-fgd-3"
              href="/privacy-policy"
            >
              {t('links.privacy')}
            </Link>
            <Link
              className="block text-th-fgd-2 md:hover:text-th-fgd-3"
              target="_blank"
              href="https://docs.cabana.exchange/"
            >
              {t('links.docs')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
